<template>
	<div class="pageTopBox space_between">
		<div class="titleText">{{title}}</div>
		<div class="addBtn">
			<el-button type="primary" size="small" v-hasPermi="[hasPermiDict]" @click="btnClick">+ 新增</el-button>
		</div>
		<!-- v-if="hasPermi([hasPermiDict])" -->
		<!-- <div class="crumbsText">首页 <span v-for="item in crumbsList">/ {{item}}</span></div> -->
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: ''
			},
			hasPermiDict: {
				type: String,
				default:''
			},
			// crumbsList: {
			// 	type: Array,
			// 	default: []
			// },
		},
		data() {
			return {

			}
		},
		methods: {
			btnClick(){
				this.$emit('btnClick')
			},
		},
		created() {

		},
		mounted() {

		},
	}
</script>

<style scoped>
	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}
	.addBtn{
		padding-right: 5px;
	}
	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}
</style>
